import { Fieldset, FileInput, Grid, TextInput } from '@mantine/core';
import { DateTimePicker } from '@mantine/dates';
import type { UseFormReturnType } from '@mantine/form';
import { IconCalendar, IconFile, IconTextCaption } from '@tabler/icons-react';
import { FormBranchMultiSelector } from '../../../components/form/FormBranchMultiSelector';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';

type UpsertRearDisplayFormProps = {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	form: UseFormReturnType<any, (values: any) => any>;
	selectedBranchIds?: string[];
};

export function UpsertRearDisplayForm({
	form,
	selectedBranchIds,
}: UpsertRearDisplayFormProps) {
	return (
		<>
			<Fieldset w={'100%'}>
				<Grid>
					<Grid.Col span={12}>
						<FileInput
							label={'Upload New Image File'}
							description={'Accepts .gif, .jpeg, .wmv, png'}
							placeholder={'Insert file...'}
							leftSection={<IconFile {...defaultIconStyle} />}
							key={form.key('file')}
							{...form.getInputProps('file')}
							data-cy="file-input"
							accept={'image/jpeg,.wmv,.png'}
							clearable
						/>
					</Grid.Col>
					<Grid.Col span={12}>
						<TextInput
							label={'Description'}
							placeholder={'Description...'}
							leftSection={<IconTextCaption {...defaultIconStyle} />}
							key={form.key('description')}
							{...form.getInputProps('description')}
							data-cy="description-input"
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<DateTimePicker
							locale="en"
							label="Start Date"
							leftSection={<IconCalendar {...defaultIconStyle} />}
							placeholder="Select start date..."
							key={form.key('startDate')}
							{...form.getInputProps('startDate')}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<DateTimePicker
							locale="en"
							label="End Date"
							leftSection={<IconCalendar {...defaultIconStyle} />}
							placeholder="Select end date..."
							key={form.key('endDate')}
							{...form.getInputProps('endDate')}
						/>
					</Grid.Col>
					<Grid.Col span={12}>
						<FormBranchMultiSelector
							form={form}
							property={'branchIds'}
							placeHolder="Select branches associated with Rear Display..."
							preselectedBranchIds={selectedBranchIds}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
		</>
	);
}
